/** @module WBS/StateColorRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/heading/stateColorResolver",
	"csi/xml"
], function(declare,Enum,stateColorResolver,xml) {

	return declare(Enum, {
		/**
		 * @override
		 * Apply the styling if needed
		 */
		_getRenderCSS: function(ctx, h) {
			const css = this.inherited(arguments);
			const node = ctx.getNode();

			if (!node) {
				return css;
			}

			const stateEnum = node.ScheduleStatus;
			
			const type = xml.enumGetId(stateEnum);
			const id = xml.enumGetText(stateEnum);
			
			return  css + " " + stateColorResolver.getStateCssByIndex(type, id);
		}
	});
});